import React ,{useState,useEffect} from 'react'

import IconButton from '@mui/material/IconButton';

import { useSelector, useDispatch } from 'react-redux'



import { styled, alpha } from '@mui/material/styles';

import Cookies from 'universal-cookie';

import {useTranslation} from "react-i18next";
import {useNavigate} from 'react-router-dom'
import {Menu,Box} from '@mui/material'
import * as RiIcons from 'react-icons/ri'


const cookies=new Cookies();
export default function DropDownGrid(props) {
    const {t, i18n} = useTranslation('common');
    const navigate = useNavigate();
  
    const dispatch=useDispatch(props);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = (dire) => {
      setAnchorEl(null);
    };
  
    const signOut=()=>{
      // cookies.remove("token");
      // window.location.href='/'
      navigate('/')
      
    }
    
    const signIn=()=>{
      // window.location.href='/'
      navigate('/')
    }
  
    return (
        <React.Fragment>
        <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
          
          {/* <Tooltip title={props?.title}> */}
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
               <RiIcons.RiSettings4Line fontSize='medium' style={{fontSize:'25px'}} />
            </IconButton>
          {/* </Tooltip> */}
        </Box>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            {props?.children}
          
        </Menu>
      </React.Fragment>
    )
}
